import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row,
  Col,
  Label,
  Button,
  FormGroup,
  Input,
  Form,
  Alert,
} from 'reactstrap';
import Select from 'react-select';

const SystemForm = ({
  system,
  saving,
  onChange,
  onSave,
  onDelete,
  onSelectChange,
  selected,
  selectedType,
  onTypeChange,
  selectedActiveOption,
  onActiveChange,
  errors,
}) => {
  return (
    <Container>
      <Row>
        <Col md={3} />
        <Col md={6}>
          <Form>
            <FormGroup>
              <Label for="id">ID</Label>
              <Input
                type="text"
                name="id"
                id="id"
                value={system.id}
                readOnly="true"
              />
            </FormGroup>
            <FormGroup>
              <Label for="systemId">System ID</Label>
              <Input
                type="text"
                name="systemId"
                id="systemId"
                value={system.systemId}
                onChange={onChange}
              />
              {errors.systemId && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.systemId}
                </Alert>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="systemName">Name</Label>
              <Input
                type="text"
                id="systemName"
                name="systemName"
                value={system.systemName}
                onChange={onChange}
              />
              {errors.systemName && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.systemName}
                </Alert>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="systemState">State</Label>
              <Select
                name="systemState"
                id="systemState"
                value={selected}
                onChange={onSelectChange}
                options={[
                  { value: 'AR', label: 'Arkansas' },
                  { value: 'MO', label: 'Missouri' },
                ]}
              />
              {errors.systemState && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.systemState}
                </Alert>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="systemType">System Type</Label>
              <Select
                name="systemType"
                id="systemType"
                value={selectedType}
                onChange={onTypeChange}
                options={[
                  { value: 'Water', label: 'Water' },
                  { value: 'Waste', label: 'Waste Water' },
                ]}
              />
              {errors.systemType && (
                <Alert className="mt-2 p-2" color={'danger'}>
                  {errors.systemType}
                </Alert>
              )}
            </FormGroup>
            <FormGroup>
              <Label for="isActive">Active System</Label>
              <Select
                name="isActive"
                id="isActive"
                value={selectedActiveOption}
                onChange={onActiveChange}
                options={[
                  { value: true, label: 'Yes' },
                  { value: false, label: 'No' },
                ]}
              />
              {errors.isActive && (
                <Alert className="my-2 p-2" color={'danger'}>
                  {errors.isActive}
                </Alert>
              )}
            </FormGroup>
            <FormGroup>
              <Button
                color="primary"
                type="submit"
                disabled={saving}
                onClick={onSave}
                className="mr-2"
              >
                {saving ? 'Saving' : 'Save'}
              </Button>
              <Button
                color="danger"
                type="submit"
                disabled={saving}
                onClick={onDelete}
              >
                {saving ? 'Deleting' : 'Delete'}
              </Button>
            </FormGroup>
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

SystemForm.propTypes = {
  system: PropTypes.object.isRequired,
};

export default SystemForm;



// WEBPACK FOOTER //
// ./src/components/system/SystemForm.js